import { c as getMainAlertContent, b as getMainAlertVisibility } from "../../../../../chunks/db.js";
async function load() {
  const alertContent = await getMainAlertContent();
  const alertVisibility = await getMainAlertVisibility();
  return {
    alert: {
      content: alertContent,
      visible: alertVisibility
    }
  };
}
export {
  load
};
